<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { roomStatus } from "../../../../../services/managements/services/roomstatus.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Room Status List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        fetchingStats: false,
        title: "Room Status List",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
        this.fetchingStats = false;
            roomStatus.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                // this.data = response;
                let data1 = response.data;
          
                 data1.forEach((item,index)=>{
                    let color = `<span style="background-color: ${item.color_code}; border-radius: 3px; font-size: 10px; padding-left: 2px; padding-right: 2px; color: #fff;">${item.color_code}</sapn>`;
                    data1[index]['color_code'] =  color;
                });


                response.data = data1;
                this.data = response;
            });
        },

        deleted: function(id) {
            roomStatus.remove(id)
                .then(response => {
                // this.customerData = response;
                if(response.status == 200) {
                    this.$swal.fire({
                    title: i18n.t('general.confirm.deleted'),
                    text: i18n.t('general.confirm.success'),
                    icon: "success",
                    confirmButtonText: i18n.t('general.ok')
                    });
                }
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-room-status-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-room-status-add'}" :title="$t('manage.room-status.text')" />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:fields="[ 
            `name: ${$t('manage.service.name')}`,
            `name_en: ${$t('manage.name_en')}`,
            `color_code: ${$t('manage.room-status.color')}`,
          ]"
          v-bind:formats="[]"
          v-bind:edit="{link: 'manage-setting-room-status-edit'}"
          v-bind:filter="{
            search: ['mg_room_statuses.name','mg_room_statuses.name_en']
          }"
          
    />      
  </Layout>
</template>